module.exports = __webpack_public_path__ + "static/iot-b8ebeb7b7c378126b44a83bad671edd5.webp";